import { sendEventV2 } from '@/utils/analytics';

export function isTwitchUrl(url: string): boolean {
    return url.includes('twitch.tv/') && !url.includes('clips.twitch.tv');
}

export function extractTwitchChannel(url: string): string | null {
    try {
        const parsed = new URL(url);
        const parts = parsed.pathname.split('/').filter(Boolean);
        return parts[0] || null;
    } catch {
        return null;
    }
}

// The Twitch embed only loads when the real embedding ancestor is an http(s) origin it can
// match against the player's `parent` list. Some hosts (the Discord client, in-app webviews,
// …) expose an ancestor origin that isn't a usable http(s) URL — e.g. an opaque "null" origin
// or a custom app scheme — and the embed silently fails there, so callers should open Twitch
// in a new window instead. An empty ancestorOrigins (we're the top frame, or the browser
// doesn't expose it) is a normal page where the embed works fine.
export function isTwitchEmbedSupported(): boolean {
    const ancestorOrigins = window.location.ancestorOrigins;
    if (!ancestorOrigins || ancestorOrigins.length === 0) return true;

    try {
        const { protocol } = new URL(ancestorOrigins[0]);
        return protocol === 'http:' || protocol === 'https:';
    } catch {
        return false;
    }
}

// Pass watchedSeconds for duration events (heartbeat / watch_time); omit it for discrete events.
export function trackTwitchEngagement(eventType: string, videoUrl: string, watchedSeconds?: number) {
    const numbers = watchedSeconds !== undefined ? [Math.round(watchedSeconds)] : [];
    sendEventV2('video_engagement', [eventType, videoUrl], numbers);
}
